import { render, staticRenderFns } from "./StudentSubcategoriesDetailed.vue?vue&type=template&id=63229847"
import script from "./StudentSubcategoriesDetailed.vue?vue&type=script&lang=ts"
export * from "./StudentSubcategoriesDetailed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports